import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";
import { GetDataFlowDeviceDetailsSchemaResData } from "./GetDataFlowDeviceDetailsSchemaResData";

const ENDPOINT = "/dataflow/devicedetails/schema";

export class GetDataFlowDeviceDetailsSchemaCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";

    params: GetDataFlowDeviceDetailsSchemaReqData = null;

    constructor(converterType: string) {
        super();
        this.params = new GetDataFlowDeviceDetailsSchemaReqData(converterType);
    }

    public async execute(): Promise<GetDataFlowDeviceDetailsSchemaResData> {
        let res = await this.executeCommand(null, null, this.params);
        return new GetDataFlowDeviceDetailsSchemaResData(res);
    }
}

export class GetDataFlowDeviceDetailsSchemaReqData {
    converterType: string;

    constructor(converterType: string) {
        this.converterType = converterType;
    }
}
